import { Block } from 'factories/block';

import { addAdvancedEditingBlock } from 'factories/advancedediting';
import { addBookmarkBlock } from 'factories/bookmark';
import { addModuleHasAudioMessageBlock } from 'factories/modulehasaudiomessage';
import { setBlocksAction } from 'actions/setBlocksAction';

const findBlockByType = (blocks, type) => {
  return Object.values(blocks).find(block => {
    return (block as Block).type === type;
  });
};

export const addAdvancedEditingBlocksToStateAction = () => (
  dispatch,
  getState
) => {
  const state = getState();
  const { blocks } = state;

  const [hasAdvancedEditing, hasBookmark, hasModuleHasAudioMessage] = [
    'AdvancedEditing',
    'Bookmark',
    'ModuleHasAudioMessage',
  ].map(entry => findBlockByType(blocks, entry));

  if (hasAdvancedEditing && hasBookmark && hasModuleHasAudioMessage) {
    console.log('module has advancedEditing blocks');
    return;
  }

  // console.log('adding advancedEditing blocks to module');

  const Module = Object.values(blocks).find(
    (b: any) => b.type === 'Module'
  ) as Block;

  if (!hasAdvancedEditing) {
    var [newBlockA, newTreeA] = addAdvancedEditingBlock(Module);
    newTreeA![newBlockA.id] = newBlockA;
  }

  if (!hasBookmark) {
    var [newBlockB, newTreeB] = addBookmarkBlock(Module);
    newTreeB![newBlockB.id] = newBlockB;
  }

  if (!hasModuleHasAudioMessage) {
    var [newBlockM, newTreeM] = addModuleHasAudioMessageBlock(Module);
    newTreeM![newBlockM.id] = newBlockM;
  }

  // dispatch({
  //   type: 'ADD_ADVANCED_EDITING_BLOCKS_TO_STATE',
  //   data: {
  //     ...(newTreeA || {}),
  //     ...(newTreeB || {}),
  //     ...(newTreeM || {}),
  //   },
  // });

  // return;

  const data = {
    ...(newTreeA || {}),
    ...(newTreeB || {}),
    ...(newTreeM || {}),
  };

  requestAnimationFrame(() => {
    setBlocksAction && dispatch(setBlocksAction(data));
  });
};
